import React, { useEffect, useState } from 'react'
import './welcomepage.css'
import { useNavigate } from "react-router-dom"
const Welcomepage = () => {
  return (
    <div className="welcomepage">
        <div className='name-intro'>
          <Loader/>
        </div>
    </div>
  )
}

const Loader = () => {
  const [progress, setProgress] = useState(0)
  const navigate = useNavigate()

  useEffect(() => {
    const interval = setInterval(() => {
      if(progress === 100){
        clearInterval(interval)
        navigate("/profile")
      }else{
        setProgress(prevState => prevState + 10)
      }
    },800)

  },[progress, navigate])

  return(
    <div className="progress">
      <div className="progress-bar" style={{width: `${progress}%`}} >
      </div>
    </div>
  )
}

export default Welcomepage